import React from "react";
import { Button, Dropdown, Input, Menu, Tooltip, Upload } from "antd";
import { DataTable } from "./DataTable";
import { YhBox } from "@/components/YhBox";
import { useRepairTemplateModel } from "../repairTemplateModel";
import useNavModel from "@/model/navModel";
import { globalPrompt } from "@/components/message";
import { useRepairTemplateDetailsModel } from "./details/repairTemplateDetailsModels";
import { IDescription, DescriptionColorEnum } from "@/components/YhBox/Types";
import { DownOutlined } from "@ant-design/icons";
import useGlobalModel from "@/model/globalModel";
import { formatNum } from "@/utils/utils";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/VrmResoureAuthEnum"
import { disableExportMsg } from "@/utils/exportFile";
import { importPropsConfig, messageConfig } from "@/utils/importFile";
export const DataBox = () => {
    const {
        loadData,
        downloadTpl,
        selectedRowKeys,
        selectedRow,
        descTotal,
        rowsDescTotal,
        setPrint,
        exportRepairTemplateRo,
        setScaniaPrint,
        setSettleScaniaPrint,
        setSelectedRowKeys
    } = useRepairTemplateModel();
    const { beShopDs, setLoadingInfo, shopAndOrg: { shopId, shopCode, shopName, shopType }, shopDs, user: { userName } } = useGlobalModel();
    const { resetEditCatch } = useRepairTemplateDetailsModel()
    const { selectedNavId, addNav, findNav, selectNav, switchNavState, replaceNav } = useNavModel();
    const upLoadCallback = (retData: any) => {
        retData?.itemMsg && messageConfig(retData.itemMsg, 20, "info");
        retData?.materialsMsg && messageConfig(retData.materialsMsg, 20, "info");
        setLoadingInfo({ loadingVisible: false, txt: "" });
        loadData()
    }
    const desc: IDescription[] = [
        {
            label: "预约单数",
            value: selectedRowKeys.length === 0 ? descTotal.num : (rowsDescTotal.num),
            color: DescriptionColorEnum.red
        },
        {
            label: "费用合计",
            value: selectedRowKeys.length === 0 ? descTotal.totalAmount : formatNum(rowsDescTotal.totalAmount),
            color: DescriptionColorEnum.red
        },
        {
            label: "营业额",
            value: selectedRowKeys.length === 0 ? descTotal.receivableTotalAmount : formatNum(rowsDescTotal.receivableTotalAmount),
            color: DescriptionColorEnum.red
        },
    ]
    const onEdit = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择单条数据进行编辑，点击鼠标右键可一键选中哦！", type: "warning" });
            return;
        }
        let repairTemplateEditKey = "13-9-2";
        let isFindNav = findNav(repairTemplateEditKey);
        if (!isFindNav) {
            addNav(repairTemplateEditKey, { id: selectedRow?.id as string, mode: "edit" });
        } else {
            globalPrompt("modal", {
                title: "预约管理跳转详情",
                type: "warning",
                text: "您还有预约管理详情未保存，是否跳转",
                okText: "跳转未保存页",
                onOk: () => selectNav(isFindNav ? isFindNav.id : ""),
                cancelText: "打开新页签",
                onCancel: () => {
                    switchNavState(repairTemplateEditKey, { id: selectedRow?.id as string, mode: "edit" });
                    resetEditCatch()
                    // updateEditFormVal(null);
                }
            })
        }
    }
    const onLook = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择单条数据进行编辑，点击鼠标右键可一键选中哦！", type: "warning" });
            return;
        }
        let supplierEditKey = "13-9-3";
        replaceNav(
            selectedNavId,
            supplierEditKey,
            { id: selectedRow.id as string, mode: "look", },
            true
        );
    }
    const onExport = () => {
        exportRepairTemplateRo().then()
    }



    const action = <>
        <YhAuth resCode={ResourceAuthEnum.VRM2_DATA_REPAIRTEMPLATE_ADD}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={() => addNav('13-9-1', { id: "", mode: "add" })}
            >新增</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.VRM2_DATA_REPAIRTEMPLATE_EDIT}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={onEdit}
            >编辑</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.VRM2_DATA_REPAIRTEMPLATE_LOOK}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={onLook}
            >查看</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.VRM2_DATA_REPAIRTEMPLATE_EXPORT}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={() => onExport()}
            >导出</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.VRM2_DATA_REPAIRTEMPLATE_IMPORT}>
            <Upload showUploadList={false} className="mr-10 ml-10" {...importPropsConfig(`/zzw-vrm/repairTemplate/list/import`, upLoadCallback, () => setLoadingInfo({ loadingVisible: true, txt: "正在导入中" }), { createUser: userName }, false)}>
                <Button className="mr-5" type="primary" shape="round">导入</Button>
            </Upload>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.VRM2_DATA_REPAIRTEMPLATE_MODELEXPORT}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={() => { downloadTpl() }}
            >下载模板</Button>
        </YhAuth>
    </>;

    return (
        // 预约管理
        <YhBox action={action} style={{ height: 'calc(100vh - 180px)' }}>
            <DataTable />
        </YhBox>
    )
}